module.exports = __webpack_public_path__ + "media/images/flags/32/Gabon-cb622ab1fdc974038baf24850de96781.png";